import { useGlobalStore } from '@/stores/global'
import { api } from '@/services'
import type { Course, Program, ParticipantRegistration } from '@/services/api'
import { useUserStore } from '@/stores/user'
import { useTourregStore } from '@/stores/tourreg'
import { useCartStore } from '@/stores/cart'

export async function accountLogout() {
  const userStore = useUserStore()
  await userStore.logout()

  const tourregStore = useTourregStore()
  await tourregStore.logout()

  const cartStore = useCartStore()
  await cartStore.logout()

  window.location.href = '/'
}

export async function fetchParticipantRegistrationsByParticipantId(id: number) {
  const globalStore = useGlobalStore()

  let list: ParticipantRegistration[] = []
  if (!id) {
    return list
  }
  try {
    globalStore.incrementLoading()
    // Fetch all pages of participant registrations (ensure full history is shown)
    let page = 1
    const perPage = 200
    while (true) {
      const response = await api.api
        .getParticipantParticipantRegistrations(id, { page, perPage })
        .then((res) => res.data)
      if (response?.data?.participant_registrations?.length) {
        list = list.concat(response.data.participant_registrations as ParticipantRegistration[])
      }
      const current = response?.current_page ?? page
      const last = response?.last_page ?? page
      if (!response || current >= last) break
      page += 1
    }
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }
  return list
}

export async function fetchParticipantProgramsByParticipantId(id: number) {
  const globalStore = useGlobalStore()

  let list: Program[] = []
  if (!id) {
    return list
  }
  try {
    globalStore.incrementLoading()
    // Fetch all pages of programs
    let page = 1
    const perPage = 200
    while (true) {
      const response = await api.api
        .getParticipantPrograms(id, { page, perPage })
        .then((res) => res.data)
      if (response?.data?.programs?.length) {
        list = list.concat(response.data.programs as Program[])
      }
      const current = response?.current_page ?? page
      const last = response?.last_page ?? page
      if (!response || current >= last) break
      page += 1
    }
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }
  return list
}

export async function fetchParticipantCoursesByParticipantId(id: number) {
  const globalStore = useGlobalStore()

  let list: Course[] = []
  if (!id) {
    return list
  }
  try {
    globalStore.incrementLoading()
    // Fetch all pages of courses
    let page = 1
    const perPage = 200
    while (true) {
      const response = await api.api
        .getParticipantCourses(id, { page, perPage })
        .then((res) => res.data)
      if (response?.data?.courses?.length) {
        list = list.concat(response.data.courses as Course[])
      }
      const current = response?.current_page ?? page
      const last = response?.last_page ?? page
      if (!response || current >= last) break
      page += 1
    }
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }
  return list
}
